import { render, staticRenderFns } from "./UserSorter.vue?vue&type=template&id=f4ac56d6&"
import script from "./UserSorter.vue?vue&type=script&lang=js&"
export * from "./UserSorter.vue?vue&type=script&lang=js&"
import style0 from "./UserSorter.vue?vue&type=style&index=0&id=f4ac56d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports